import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { Tooltip } from "@mui/material";

const SelectMenuItems = ({
  title = "",
  backGroundColor = "transparent",
  ItemsList = [],
  RequiredFontSize = "inherit",
  MenuItemFontSize = "13px",
  showHeader = true,
  showEndIcon = true,
  icon = null,
  handleStatuUpdate = () => { },
  handlePriorityUpdate = () => { },
  handleClearFilters = () => { },
  className = "",
  menuClassName = "",
  isEpicMenuList = false

}) => {
  const [gallery, setGallery] = useState(null);
  const [selectedValue, setSelectedValue] = useState(title);

  useEffect(() => {
    setSelectedValue(title);
  }, [title]);


  const handleClick = (event) => {
    setGallery(event.currentTarget);
  };


  const handleChangeSelectedValue = (value) => {
    const displayValue = value.name || value.title;
    if (title === "Epic") {
      handleClearFilters()
    }
    setSelectedValue(displayValue);
    handleStatuUpdate(displayValue);
    handlePriorityUpdate(displayValue);
    setGallery(null);
    // setSelectedValue(value.name);
    // handleStatuUpdate(value.name);
    // handlePriorityUpdate(value.name)
    // setGallery(null);

  };

  const handleClose = () => {
    setGallery(null);
  };

  // const handleClear = () => {
  //   setGallery(null);
  //   console.log("Clear clicked");
  // };

  // const getDisplayValue = (value) => {
  //   if (value === "In Review") return "Code Review";
  //   if (value === "QA") return "In Testing";
  //   return value;
  // };

  const open = Boolean(gallery);

  const STATUS_TONE = {
    "To Do": { backgroundColor: "#eef0f4", color: "#59637a", borderColor: "#e4e7ee" },
    "In Progress": { backgroundColor: "#eaf1fd", color: "#1657ad", borderColor: "#dbe8fc" },
    "Code Review": { backgroundColor: "#fdf1e7", color: "#a3541a", borderColor: "#f7e1cd" },
    "In Review": { backgroundColor: "#fdf1e7", color: "#a3541a", borderColor: "#f7e1cd" },
    "In Testing": { backgroundColor: "#f1eefc", color: "#4a3aa7", borderColor: "#e2dcf7" },
    QA: { backgroundColor: "#f1eefc", color: "#4a3aa7", borderColor: "#e2dcf7" },
    "Production Ready": { backgroundColor: "#e6f6f0", color: "#10705a", borderColor: "#cfeade" },
    Done: { backgroundColor: "#e8f7ef", color: "#0b7a45", borderColor: "#cdeddd" },
  };

  const statusTone = STATUS_TONE[selectedValue];

  // pill geometry only where a status matched, so other dropdowns keep their
  // current size and don't reflow the toolbars they sit in
  let btnStyles = statusTone
    ? {
        ...statusTone,
        border: `1px solid ${statusTone.borderColor}`,
        borderRadius: "999px",
        padding: "3px 12px",
        fontWeight: 600,
        lineHeight: 1.4,
        whiteSpace: "nowrap",
      }
    : { backgroundColor: backGroundColor, color: "#7B7C7B" };

  return (
    <div>
      <Button
        onClick={handleClick}
        className={`${className} ${backGroundColor ? "mx-2" : ""}`}
        startIcon={icon}
        endIcon={
          showEndIcon ? open ? <ExpandLessIcon /> : <ExpandMoreIcon /> : null
        }
        style={{
          boxShadow: "none",
          textTransform: "none",
          fontSize: RequiredFontSize,
          ...btnStyles,
        }}
        sx={
          statusTone
            ? {
                "& .MuiButton-startIcon": { marginRight: "6px", marginLeft: 0 },
                "& .MuiButton-endIcon": { marginLeft: "4px", opacity: 0.55 },
                "& .MuiButton-endIcon svg": { fontSize: "1rem" },
              }
            : undefined
        }
        size="small"
      >
        {selectedValue}
      </Button>
      <Menu
        anchorEl={gallery}
        open={open}
        onClose={handleClose}
        slotProps={menuClassName ? { paper: { className: menuClassName } } : undefined}
      >
        {(ItemsList && ItemsList?.length > 0) ? ItemsList?.map((eachItem, index) => (
          isEpicMenuList ? <Tooltip key={`${index}-${eachItem?.name}`} title={eachItem?.summary} placement="right">
            <MenuItem
              onClick={() => handleChangeSelectedValue(eachItem)}
              key={index}
              className="px-3"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                fontSize: MenuItemFontSize,
              }}
            >
              {(eachItem?.icon) ? (eachItem?.icon) : ''}
              {eachItem?.name || eachItem?.title}
            </MenuItem></Tooltip> : <MenuItem
              onClick={() => handleChangeSelectedValue(eachItem)}
              key={index}
              className="px-3"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                fontSize: MenuItemFontSize,
              }}
            >
            {(eachItem?.icon) ? (eachItem?.icon) : ''}
            {eachItem?.name || eachItem?.title}
          </MenuItem>
        )) : <MenuItem onClick={() => handleClose()}> No Data Available</MenuItem>}
      </Menu>
    </div>
  );
};

export default SelectMenuItems;
